import React from "react";
import { makeStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import { SingleInputField } from "../../../components";
import { adminLoginData } from "../../../assets/lib/login";

const useStyles = makeStyles({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    backgroundColor: "#fff", // white background
    color: "#000", // black text
    fontFamily: "Montserrat"
  },
  loginBox: {
    backgroundColor: "#fff", // white box
    padding: "40px",
    borderRadius: "12px",
    border: "1px solid #ccc",
    boxShadow: "0 0 15px rgba(0,0,0,0.05)",
    width: "100%",
    maxWidth: "400px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    fontFamily: "Montserrat"
  },
  title: {
    margin: 0,
    fontSize: "24px",
    fontWeight: "bold",
    textAlign: "center",
    color: "#000",
    fontFamily: "Montserrat"
  },
  subtitle: {
    margin: 0,
    fontSize: "16px",
    textAlign: "center",
    color: "#555",
    fontFamily: "Montserrat"
  },
  inputContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    fontFamily: "Montserrat"
  },
});

const Layout = ({ loginState, errorFields, getLoginInput, handleLogin, loginFailedText }) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.loginBox}>
  <h1 className={classes.title}>Admin Portal</h1>
  <h2 className={classes.subtitle}>Sign in with your admin credentials</h2>

  {!!loginFailedText && <p style={{ color: "red",fontFamily: "Montserrat" }}>{loginFailedText}</p>}

  <div className={classes.inputContainer}>
    <SingleInputField
      content={adminLoginData.email}
      value={loginState.email}
      getInputData={getLoginInput}
      errorFields={errorFields}
    />
    <SingleInputField
      content={adminLoginData.password}
      value={loginState.password}
      getInputData={getLoginInput}
      errorFields={errorFields}
    />
  </div>

  <Button
    variant="contained"
    sx={{ bgcolor: "#000", color: "#fff", fontWeight: "bold",fontFamily: "Montserrat" }}
    onClick={handleLogin}
  >
    Login
  </Button>
</div>

    </div>
  );
};

export default Layout;
